import { Action } from 'redux'

import { ADD_SPECIAL_SSR_MODAL_DATA } from '../../actions/ssrs/addSpecialSSRModalData'
import { CLOSE_SPECIAL_SSR_MODAL } from '../../actions/modals/closeSpecialSSRModal'

export interface SpecialSSRModalAction extends Action {
  passengerId: string
  ssrId: string
}

export interface SpecialSSRModalInterface {
  passengerId: string
  ssrId: string
}

export const initialState: SpecialSSRModalInterface = {
  passengerId: '',
  ssrId: '',
}

export default (
  state = initialState,
  action: SpecialSSRModalAction = { type: '', passengerId: '', ssrId: '' }
) => {
  const { type, passengerId, ssrId } = action

  switch (type) {
    case ADD_SPECIAL_SSR_MODAL_DATA:
      return {
        ...state,
        passengerId,
        ssrId,
      }

    case CLOSE_SPECIAL_SSR_MODAL:
      return initialState

    default:
      return state
  }
}
